import React from "react";
import {
  Page,
  Text,
  Image,
  View,
  Document,
  PDFDownloadLink,
  StyleSheet,
  Link,
  Svg,
  Path,
} from "@react-pdf/renderer";
import logobig from "../../../../assets/Aara_logo.png";

import logosmall from "../../../../assets/pdf_images/img54.jpg"; // Replace with the correct path
import counselingImage from "../../../../assets/pdf_images/counseling.jpg"; // Replace with the correct path

// import Roboto from "../../../../assets/fonts/Robobto-Regular.ttf";
import Roboto from "../../../../assets/fonts/Roboto-Regular.ttf";
import RobotoBold from "../../../../assets/fonts/Roboto-Bold.ttf";
import RobotoBlack from "../../../../assets/fonts/Roboto-Black.ttf";
import OpenSauceRegular from "../../../../assets/fonts/OpenSauceSans-Regular.ttf";
import OpenSauceBold from "../../../../assets/fonts/OpenSauceSans-Bold.ttf";
import ladder from "../../../../assets/pdf_images/ladder.jpg";
import mountain from "../../../../assets/pdf_images/mountain.jpg";
import swotImage from "../../../../assets/pdf_images/swotImage.jpg";
import keyBenefitsWide from "../../../../assets/pdf_images/key_benefits_wide.png";
import careerArt from "../../../../assets/pdf_images/career_art.png";
import { Font } from "@react-pdf/renderer";
import threatImage from "../../../../assets/pdf_images/threatImage.png";
import Globe from "../../../../assets/pdf_images/glo.png";
import Envelope from "../../../../assets/pdf_images/env.png";
import Phone from "../../../../assets/pdf_images/phone.jpg";
import Location from "../../../../assets/pdf_images/locat.png";
import { pdf } from "@react-pdf/renderer";

Font.register({
  family: "Roboto",
  format: "truetype",
  src: Roboto,
});

Font.register({
  family: "Roboto-bold",
  format: "truetype",
  src: RobotoBold,
});

Font.register({
  family: "OpenSauce",
  format: "truetype",
  src: OpenSauceRegular,
});

Font.register({
  family: "OpenSauce-bold",
  format: "truetype",
  src: OpenSauceBold,
});

Font.register({
  family: "Roboto-black",
  format: "truetype",
  src: RobotoBlack,
});

Font.registerHyphenationCallback((word) => [word]);

const DotGrid = () => (
  <View style={styles.dotGrid}>
    {Array.from({ length: 24 }).map((_, index) => (
      <View key={`dot-${index}`} style={styles.dot}></View>
    ))}
  </View>
);

const PageDecor = () => (
  <>
    <View style={styles.topBar}>
      <View style={styles.topBarBlue}></View>
      <View style={styles.topBarViolet}></View>
      <View style={styles.topBarAmber}></View>
      <View style={styles.topBarCoral}></View>
    </View>
    <View style={styles.cornerGlowPrimary}></View>
    <View style={styles.cornerGlowSecondary}></View>
    <View style={styles.ringOne}></View>
    <View style={styles.ringTwo}></View>
    <DotGrid />
    <View style={styles.bottomBar}>
      <View style={styles.bottomBarCoral}></View>
      <View style={styles.bottomBarAmber}></View>
      <View style={styles.bottomBarViolet}></View>
      <View style={styles.bottomBarBlue}></View>
    </View>
  </>
);

const HeaderMark = ({ label }) => (
  <View style={styles.headerMark}>
    <View style={styles.headerMarkDot}></View>
    <Text fixed wrap={false} style={styles.headerMarkText}>
      {label}
    </Text>
  </View>
);

const SectionKicker = ({ label }) => (
  <View style={styles.sectionKicker}>
    <View style={styles.sectionKickerDot}></View>
    <Text fixed wrap={false} style={styles.sectionKickerText}>
      {label}
    </Text>
  </View>
);

const splitReportPoints = (value) =>
  String(value || "")
    .split(".")
    .map((point) => point.trim())
    .filter(Boolean);

const getSwotPoint = (section, field, fallbackIndex) => {
  if (typeof field === "string") {
    return { label: `Point ${fallbackIndex + 1}`, body: field };
  }

  const label =
    field?.attribute ||
    field?.field_name ||
    field?.title ||
    `Point ${fallbackIndex + 1}`;
  const body =
    section === "strengths"
      ? field?.strength || field?.profile_description || field?.description
      : field?.weakness ||
      field?.at_weakness ||
      field?.profile_description ||
      field?.description;

  return { label, body };
};

// const userDetail = {
//   id: 184,
//   name: "John Doe",
//   email: "johnwderf@example.com",
//   phone: "1234567890",
//   alt_phone: "0987654321",
//   pdf_link: null,
// };

// Page 1 Component — COVER
const Page1 = ({ userDetail, testDate }) => (
  <Page size="A4" style={styles.page}>
    <PageDecor />

    {/* AI Badge */}
    <View style={styles.aiBadgeContainer}>
      <Svg viewBox="0 0 24 24" width={13} height={13} style={{ marginRight: 6 }}>
        <Path d="M12 2L14.4 9.6L22 12L14.4 14.4L12 22L9.6 14.4L2 12L9.6 9.6L12 2Z" fill="#4F46E5" />
      </Svg>
      <Text fixed wrap={false} style={styles.aiBadgeText}>AI-Powered Career Assessment</Text>
    </View>

    {/* Logo */}
    <View style={styles.coverLogoWrap}>
      <Image src={logobig} style={styles.logo} />
    </View>

    {/* Title block */}
    <View style={styles.coverTitleBlock}>
      <Text fixed wrap={false} style={styles.coverTitleSwot}>SWOT</Text>
      <Text fixed wrap={false} style={styles.coverTitleSub}>TEST REPORT</Text>
    </View>

    {/* Decorative divider */}
    <View style={styles.coverDivider}>
      <View style={styles.coverDividerLine}></View>
      <View style={styles.coverDividerDot}></View>
    </View>

    {/* Cover illustration */}
    <View style={styles.coverArtWrap}>
      <Image src={ladder} style={styles.coverArtImg} />
    </View>

    {/* User info card */}
    <View style={styles.coverInfoCard}>
      <SectionKicker label="PERSONAL INSIGHT REPORT" />
      <View style={styles.coverInfoRow}>
        <View style={styles.coverAvatar}>
          <View style={styles.avatarHead}></View>
          <View style={styles.avatarBody}></View>
        </View>
        <Text fixed wrap={false} style={styles.coverUserName}>{userDetail.name}</Text>
      </View>
      <View style={styles.coverDateRow}>
        <View style={styles.coverCalIcon}>
          <View style={styles.coverCalHeader}></View>
          <View style={styles.coverCalDots}>
            <View style={styles.coverCalDot}></View>
            <View style={styles.coverCalDot}></View>
            <View style={styles.coverCalDot}></View>
          </View>
        </View>
        <Text fixed wrap={false} style={styles.coverDateText}>Test taken on {testDate}</Text>
      </View>
    </View>
  </Page>
);

const Page2 = () => (
  <Page size="A4" style={styles.page}>
    {/* Header */}
    <View style={styles.pageHeader}>
      <View style={styles.pageHeaderAccent}></View>
      <Text fixed wrap={false} style={styles.pageTitle}>Introduction</Text>
      <Image src={logosmall} style={styles.logoSmall} />
    </View>

    {/* Two-column intro */}
    <View style={styles.introRow}>
      <View style={styles.introLeftCol}>
        <Text fixed wrap={false} style={styles.introSubheading}>
          Understand Yourself.{"\n"}Plan Your Growth.
        </Text>
        <View style={styles.introMiniDivider}>
          <View style={styles.introMiniDividerLine}></View>
          <View style={styles.introMiniDividerDot}></View>
        </View>
        <Text fixed wrap={false} style={styles.introText}>
          The <Text style={styles.boldText}>SWOT TEST</Text> helps individuals identify what they're good at, areas they can improve, chances they can take advantage of, and challenges they may face. This test can be helpful for personal development and career planning by providing insights into one's internal and external factors.
        </Text>
      </View>
      <View style={styles.introRightCol}>
        <Image src={swotImage} style={styles.introSwotImage} />
      </View>
    </View>

    {/* Key Benefits divider */}
    <View style={styles.benefitsDividerContainer}>
      <View style={styles.benefitsDividerLine}></View>
      <View style={styles.benefitsDividerDot}></View>
      <Text fixed wrap={false} style={styles.benefitsDividerText}>KEY BENEFITS</Text>
      <View style={styles.benefitsDividerDot}></View>
      <View style={styles.benefitsDividerLine}></View>
    </View>

    {/* Key benefits visual */}
    <View style={styles.keyBenefitsImageWrap}>
      <Image src={keyBenefitsWide} style={styles.keyBenefitsImage} />
    </View>

    <PageDecor />
  </Page>
);

const Page3 = ({ data, profileChunks, userDetail }) => (
  <>
    {profileChunks.map((chunk, pageIndex) => (
      <Page key={`page3-${pageIndex}`} size="A4" style={styles.page}>
        <PageDecor />

        {/* Header */}
        <View style={styles.pageHeader}>
          <View style={styles.pageHeaderAccent}></View>
          <Text fixed wrap={false} style={styles.pageTitle}>Profile</Text>
          <Image src={logosmall} style={styles.logoSmall} />
        </View>

        {/* Profile Description */}
        <View style={[styles.section, { marginTop: 10 }]}>
          {pageIndex === 0 && (
            <Text wrap={false} style={[styles.sectionTitle, { marginTop: 0 }]}>
              {userDetail.name}'s Profile
            </Text>
          )}
          {chunk.map((item, index) => (
            <View key={index} style={styles.profileCard}>
              <Text wrap={false} style={styles.profileCardIndex}>
                {String(index + 1 + pageIndex * 6).padStart(2, "0")}
              </Text>
              <Text wrap={false} style={styles.text}>
                {item.profile_description?.replace(/{name}/g, userDetail.name)}
              </Text>
            </View>
          ))}
        </View>

        {/* Career Fields (only on last page of section) */}
        {pageIndex === profileChunks.length - 1 && (
          <View wrap={false} style={[styles.section, { marginTop: 10 }]}>
            <Text wrap={false} style={styles.sectionTitle}>
              PROBABLE CAREER FIELDS
            </Text>
            <View style={styles.careerFieldsWrap}>
              {data.career_fields.map((field, index) => (
                <View key={index} style={styles.careerFieldPill}>
                  <View style={styles.careerFieldDot}></View>
                  <Text wrap={false} style={styles.careerFieldText}>
                    {field.field_name}
                  </Text>
                </View>
              ))}
            </View>
          </View>
        )}

        {/* Background illustration */}
        <View style={styles.pageArtWrap}>
          <Image src={careerArt} style={styles.pageArtImg} />
        </View>

      </Page>
    ))}
  </>
);

const Page4 = ({ careerDataChunks }) => (
  <>
    {careerDataChunks.map((chunk, chunkIndex) => (
      <Page key={chunkIndex} size="A4" style={styles.page}>
        <PageDecor />

        {/* Header */}
        <View style={styles.pageHeader}>
          <View style={styles.pageHeaderAccent}></View>
          <Text fixed wrap={false} style={styles.pageTitle}>Probable Career Choice</Text>
        </View>

        {/* Content Section */}
        <View style={styles.contentSection}>
          <View style={[styles.flex1, { flex: 1 }]}>
            {chunk.map((career, index) => (
              <View key={index} style={styles.careerContainer}>
                <Text wrap={false} style={styles.careerTitle}>
                  {career.field_name}
                </Text>
                <Text wrap={false} style={styles.careerDescription}>
                  {career.description}
                </Text>
                <Text wrap={false} style={styles.exampleHeader}>
                  <Text wrap={false} style={styles.bold}>Example:</Text>
                </Text>
                {career.example2 ? (
                  <View>
                    <View style={styles.exampleItem}>
                      <Text wrap={false} style={styles.bulletPoint}>•</Text>
                      <Text wrap={false} style={styles.textExample}>{career.example1}</Text>
                    </View>
                    <View style={styles.exampleItem}>
                      <Text wrap={false} style={styles.bulletPoint}>•</Text>
                      <Text wrap={false} style={styles.textExample}>{career.example2}</Text>
                    </View>
                  </View>
                ) : (
                  <Text wrap={false} style={styles.textExample}>{career.example1}</Text>
                )}
              </View>
            ))}
          </View>
        </View>
        {/* Bottom Logo */}
        <View style={styles.swotBottomLogoContainer}>
          <Image src={logosmall} style={styles.swotBottomLogo} />
        </View>
      </Page>
    ))}
  </>
);

const Page5 = ({ data, swotChunks }) => {
  const maxFieldsPerPage = 6;
  return (
    <>
      {Object.entries(swotChunks).map(([section, chunks]) =>
        chunks.map((fieldsChunk, chunkIndex) => (
          <Page key={`${section}-${chunkIndex}`} size="A4" style={styles.page}>
            <PageDecor />

            {/* Header */}
            <View style={styles.pageHeader}>
              <View style={styles.pageHeaderAccent}></View>
              <Text fixed wrap={false} style={styles.pageTitle}>Swot analysis</Text>
            </View>

            {/* Section Title */}
            <View style={[styles.section, { flex: 1 }]}>
              <View style={{ marginBottom: 10 }}>
                <Text wrap={false} style={styles.swotSectionTitle}>
                  {section.charAt(0).toUpperCase() + section.slice(1).toLowerCase()}
                </Text>
              </View>

              {/* Content */}
              {fieldsChunk.map((field, fieldIndex) => {
                const fieldName =
                  data.career_fields[
                    chunkIndex * maxFieldsPerPage + fieldIndex
                  ]?.field_name || `Career field ${fieldIndex + 1}`;
                const points = splitReportPoints(field);
                const swotPoint = getSwotPoint(section, field, fieldIndex);

                if (section !== "opportunities" && !swotPoint.body) {
                  return null;
                }

                return (
                  <View key={fieldIndex} style={styles.swotDetailCard}>
                    <View style={styles.swotDetailHeader}>
                      <View style={styles.swotNumberBadge}>
                        <Text style={styles.swotNumberText}>
                          {chunkIndex * maxFieldsPerPage + fieldIndex + 1}
                        </Text>
                      </View>
                      <Text wrap={false} style={styles.swotDetailTitle}>
                        {section === "opportunities" ? fieldName : swotPoint.label}
                      </Text>
                    </View>

                    {section === "opportunities" ? (
                      points.map((item, index) => (
                        <View key={index} style={styles.swotBulletRow}>
                          <Text style={styles.swotBullet}>•</Text>
                          <Text style={styles.swotBulletText}>{item}</Text>
                        </View>
                      ))
                    ) : (
                      <Text wrap={false} style={styles.swotBodyText}>
                        {swotPoint.body}
                      </Text>
                    )}
                  </View>
                );
              })}
            </View>

            {/* Bottom Right Logo */}
            <View style={styles.swotBottomLogoContainer}>
              <Image src={logosmall} style={styles.swotBottomLogo} />
            </View>
          </Page>
        ))
      )}
    </>
  );
};

const Page6 = ({ threatChunks, threatsLength }) => {
  const maxFieldsPerPage = 6;
  return (
    <>
      {threatChunks.threats.map((threatChunk, chunkIndex) => (
        <Page key={`threat-${chunkIndex}`} size="A4" style={styles.page}>
          <PageDecor />

          {/* Header */}
          <View style={styles.pageHeader}>
            <View style={styles.pageHeaderAccent}></View>
            <Text fixed wrap={false} style={styles.pageTitle}>Swot analysis</Text>
          </View>

          <View style={styles.contentSection}>
            <View style={styles.section}>
              <Text fixed wrap={false} style={styles.swotSectionTitle}>
                Threats
              </Text>
              <View style={styles.threatList}>
                {threatChunk.map((threat, index) => {
                  const bulletPoints = splitReportPoints(threat);
                  return (
                    <View key={index} style={styles.swotDetailCard}>
                      <View style={styles.swotDetailHeader}>
                        <View style={styles.swotNumberBadge}>
                          <Text style={styles.swotNumberText}>
                            {chunkIndex * maxFieldsPerPage + index + 1}
                          </Text>
                        </View>
                        <Text style={styles.swotDetailTitle}>
                          {
                            threatChunks.field_name[
                            chunkIndex * maxFieldsPerPage + index
                            ]
                          }
                        </Text>
                      </View>
                      {bulletPoints.map((item, pointIndex) => (
                        <View key={pointIndex} style={styles.swotBulletRow}>
                          <Text style={styles.swotBullet}>•</Text>
                          <Text style={styles.swotBulletText}>{item}</Text>
                        </View>
                      ))}
                    </View>
                  );
                })}
              </View>
            </View>

            {/* Bottom Right Logo */}
            <View style={styles.swotBottomLogoContainer}>
              <Image src={logosmall} style={styles.swotBottomLogo} />
            </View>
          </View>
        </Page>
      ))}
    </>
  );
};

// Page 7 Component (Contact)
const Page7 = () => (
  <Page size="A4" style={styles.page}>
    <PageDecor />
    {/* Logo Container (Centered) */}
    <View style={[styles.logoBigContainer, { marginTop: 40, marginBottom: 15 }]}>
      <Image src={logosmall} style={[styles.logobig, { width: 220, maxWidth: 220 }]} />
    </View>

    {/* Counseling Image */}
    <View style={styles.counselingImageContainer}>
      <Image src={counselingImage} style={styles.counselingImage} />
    </View>

    {/* Call to Action */}
    <Link
      src="https://aaraconsultancy.com/one-on-one-counseling/"
      style={{ textDecoration: "none", color: "black" }}
    >
      <View style={styles.button}>
        <Text fixed wrap={false} style={styles.buttonText}>
          Book Your 1-1 Counseling
        </Text>
      </View>
    </Link>

    {/* Address Section */}
    <View style={styles.addressSection}>
      <View style={styles.addressItem}>
        <Image src={Location} style={styles.icon} />
        <View style={{ flex: 1, marginLeft: 10 }}>
          <Link
            style={{ textDecoration: "none", color: "black" }}
            src="https://www.google.com/search?sca_esv=588668658&rlz=1C1YTUH_enIN1058IN1059&sxsrf=AM9HkKn-VsXce-kL4pCxnEtDHMIxKTQWJA:1701937726300&q=Aara+Education+Consultancy+-+Study+Abroad+and+Career+Counsellor+in+Mumbai&ludocid=13256448219233310615&lsig=AB86z5VG0zrTuOFFKhDWbLFzKqot&kgs=20992ba1dc59403c&shndl=-1&shem=lsp&source=sh/x/kp/local/m1/1"
          >
            <Text style={styles.addressMain}>
              <Text style={styles.addressTitle}>Vidyavihar: </Text>
              608, 6th Floor, Surya House, Road Number 7, opposite R.N Gandhi High School, near Vidyavihar station (east), Rajawadi Colony, Mumbai, Maharashtra 400077
            </Text>
          </Link>
        </View>
      </View>
      <View style={styles.addressItem}>
        <Image src={Location} style={styles.icon} />
        <View style={{ flex: 1, marginLeft: 10 }}>
          <Link
            style={{ textDecoration: "none", color: "black" }}
            src="https://www.bing.com/search?q=aara+consultancy+andheri&cvid=381bc89bba5b446d9b3597d03011ad57&gs_lcrp=EgRlZGdlKgYIABAAGEAyBggAEAAYQDIGCAEQRRg8MgYIAhBFGD0yBggDEEUYPDIICAQQ6QcY8gcyCAgFEOkHGPIHMggIBhDpBxj8VdIBCDQzMjdqMGo0qAIAsAIB&FORM=ANAB01&PC=DCTS"
          >
            <Text style={styles.addressMain}>
              <Text style={styles.addressTitle}>Andheri: </Text>
              DN Nagar Metro Station, 1308 Lotus Link Square, Besides, JP Rd, D.N.Nagar, Andheri West, Mumbai, Maharashtra 400053
            </Text>
          </Link>
        </View>
      </View>
    </View>

    {/* Contact Details */}
    <View style={styles.contactSection}>
      <View style={styles.contactItem}>
        <Image src={Phone} style={styles.contactIcon} />
        <Link
          src="tel:+918108745275"
          style={{ textDecoration: "none", color: "black" }}
        >
          <Text style={styles.contactText}>
            +91 8108 745 275
          </Text>
        </Link>
      </View>
      <View style={styles.contactItem}>
        <Image src={Envelope} style={styles.contactIcon} />
        <Link
          src="mailto:info@aaraconsultancy.com"
          style={{ textDecoration: "none", color: "black" }}
        >
          <Text style={styles.contactText}>
            info@aaraconsultancy.com
          </Text>
        </Link>
      </View>
      <View style={styles.contactItem}>
        <Image src={Globe} style={styles.contactIcon} />
        <Link
          src="https://www.aaraconsultancy.com"
          style={{ textDecoration: "none", color: "black" }}
        >
          <Text style={styles.contactText}>
            www.aaraconsultancy.com
          </Text>
        </Link>
      </View>
    </View>
  </Page>
);

// PDF Document with Multiple Pages
export const PDFDocument = ({ data, userDetail }) => {
  // export const PDFDocument = () => {
  const chunkCareerData = (data, size) => {
    const chunks = [];
    for (let i = 0; i < data.length; i += size) {
      chunks.push(data.slice(i, i + size));
    }
    return chunks;
  };

  const careerDataChunks = chunkCareerData(data.career_fields, 2);
  const maxFieldsPerPage = 6;
  const chunkData = (array, size) => {
    const chunks = [];
    for (let i = 0; i < array.length; i += size) {
      chunks.push(array.slice(i, i + size));
    }
    return chunks;
  };

  const opportunities = data.career_fields
    .map((f) => f.opportunities)
    .filter((op) => op && op.length > 0);
  const swotChunks = {
    strengths: chunkData(data.strengths || [], maxFieldsPerPage),
    weaknesses: chunkData(data.weaknesses || [], maxFieldsPerPage),
    opportunities: chunkData(opportunities.flat() || [], 6), // Limit to 6 per page
  };

  const threats = data.career_fields
    .map((f) => f.threats)
    .filter((th) => th && th.length > 0);
  const threatChunks = {
    field_name: data.career_fields
      .filter((f) => f.threats && f.threats.length > 0)
      .map((f) => f.field_name),
    threats: chunkData(threats.flat() || [], 6), // Limit to 6 per page
  };

  // const swotChunks = {
  //   strengths: chunkData(data.strengths || [], maxFieldsPerPage),
  //   weaknesses: chunkData(data.weaknesses || [], maxFieldsPerPage),
  //   opportunities: chunkData(
  //     data.career_fields?.map((f) => f.opportunities) || [],
  //     3
  //   ),
  // };

  const threatsLength =
    data.career_fields?.flatMap((f) => f.threats).length || 0;

  // const threatChunks = {
  //   field_name: data.career_fields.map((f) => f.field_name),
  //   threats: chunkData(data.career_fields?.map((f) => f.threats) || [], 4),
  // };
  // threatChunks);
  const profilesPerPage = 6;
  const profileChunks = chunkData(data.strengths, profilesPerPage);
  const testDate = new Date().toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
  return (
    <Document>
      <Page1 userDetail={userDetail} testDate={testDate} />
      <Page2 />
      <Page3
        data={data}
        profileChunks={profileChunks}
        userDetail={userDetail}
      />
      <Page4 careerDataChunks={careerDataChunks} />
      <Page5 data={data} swotChunks={swotChunks} />
      <Page6 threatChunks={threatChunks} threatsLength={threatsLength} />
      <Page7 />
    </Document>
  );
};

export default PDFDocument;

// ─── REDESIGNED STYLES ───
const styles = StyleSheet.create({
  page: {
    fontFamily: "Roboto",
    position: "relative",
    backgroundColor: "#FFFDF7",
    minHeight: "100%",
    paddingTop: 0,
    paddingRight: 28,
    paddingBottom: 0,
    paddingLeft: 28,
    overflow: "hidden",
  },
  topBar: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: 8,
    flexDirection: "row",
  },
  topBarBlue: { flex: 1.4, backgroundColor: "#2563EB" },
  topBarViolet: { flex: 1, backgroundColor: "#7C3AED" },
  topBarAmber: { flex: 0.8, backgroundColor: "#F59E0B" },
  topBarCoral: { flex: 0.8, backgroundColor: "#F43F5E" },
  bottomBar: {
    position: "absolute",
    bottom: 0,
    left: 0,
    width: "100%",
    height: 8,
    flexDirection: "row",
  },
  bottomBarBlue: { flex: 1.2, backgroundColor: "#2563EB" },
  bottomBarViolet: { flex: 1, backgroundColor: "#7C3AED" },
  bottomBarAmber: { flex: 0.8, backgroundColor: "#F59E0B" },
  bottomBarCoral: { flex: 1, backgroundColor: "#F43F5E" },
  aiBadgeContainer: {
    position: "absolute",
    top: 28,
    right: 28,
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#EEF2FF",
    paddingVertical: 6,
    paddingHorizontal: 12,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: "#C7D2FE",
  },
  aiBadgeText: {
    fontFamily: "OpenSauce-bold",
    fontWeight: "bold",
    fontSize: 10,
    color: "#3730A3",
    letterSpacing: 0.5,
  },
  cornerGlowPrimary: {
    position: "absolute",
    width: 160,
    height: 160,
    borderRadius: 80,
    backgroundColor: "#DBEAFE",
    top: -56,
    right: -82,
    opacity: 0.5,
  },
  cornerGlowSecondary: {
    position: "absolute",
    width: 150,
    height: 150,
    borderRadius: 75,
    backgroundColor: "#FEF3C7",
    bottom: -58,
    left: -72,
    opacity: 0.48,
  },
  ringOne: {
    position: "absolute",
    width: 72,
    height: 72,
    borderRadius: 36,
    borderWidth: 6,
    borderColor: "#C4B5FD",
    bottom: 72,
    right: 44,
    opacity: 0.22,
  },
  ringTwo: {
    position: "absolute",
    width: 46,
    height: 46,
    borderRadius: 23,
    borderWidth: 5,
    borderColor: "#FDBA74",
    bottom: 128,
    right: 104,
    opacity: 0.2,
  },
  dotGrid: {
    position: "absolute",
    bottom: 56,
    right: 34,
    width: 82,
    flexDirection: "row",
    flexWrap: "wrap",
    opacity: 0.16,
  },
  dot: {
    width: 3,
    height: 3,
    borderRadius: 1.5,
    backgroundColor: "#2563EB",
    marginRight: 9,
    marginBottom: 9,
  },
  section: { marginTop: 10, paddingRight: 18 },
  sectionTitle: {
    fontSize: 18,
    fontFamily: "OpenSauce-bold",
    fontWeight: "bold",
    marginBottom: 12,
    marginTop: 18,
    color: "#4C1D95",
  },
  boldText: { fontFamily: "Roboto-bold", fontWeight: "bold" },
  text: {
    marginBottom: 0,
    fontSize: 11.5,
    lineHeight: 1.55,
    textAlign: "justify",
    color: "#334155",
    flex: 1,
  },
  // Cover (Page1)
  coverLogoWrap: { marginTop: 34, padding: 5 },
  logo: { width: 140 },
  coverTitleBlock: { marginTop: 38, marginLeft: 28 },
  coverTitleSwot: {
    fontFamily: "OpenSauce-bold",
    fontSize: 76,
    color: "#111827",
    lineHeight: 0.98,
  },
  coverTitleSub: {
    fontFamily: "OpenSauce-bold",
    fontSize: 56,
    color: "#2563EB",
    lineHeight: 1,
    marginTop: -1,
  },
  coverDivider: {
    flexDirection: "row",
    alignItems: "center",
    marginLeft: 30,
    marginTop: 28,
    marginBottom: 26,
    width: 292,
  },
  coverDividerLine: {
    flex: 1,
    height: 4,
    backgroundColor: "#7C3AED",
    borderRadius: 2,
  },
  coverDividerDot: {
    width: 10,
    height: 10,
    borderRadius: 5,
    backgroundColor: "#F59E0B",
    marginLeft: -5,
  },
  coverInfoCard: {
    marginLeft: 30,
    marginTop: 10,
    backgroundColor: "#FFFFFF",
    borderRadius: 16,
    padding: 16,
    borderWidth: 1.5,
    borderColor: "#BFDBFE",
    width: 340,
  },
  coverInfoRow: { flexDirection: "row", alignItems: "center", marginBottom: 12 },
  coverAvatar: {
    width: 46,
    height: 46,
    borderRadius: 23,
    backgroundColor: "#2563EB",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
    marginRight: 12,
  },
  avatarHead: { width: 12, height: 12, borderRadius: 6, backgroundColor: "#FFFFFF", marginTop: 5 },
  avatarBody: { width: 24, height: 14, borderRadius: 12, backgroundColor: "#FFFFFF", marginTop: 2 },
  coverUserName: { fontSize: 24, fontFamily: "OpenSauce-bold", fontWeight: "bold", color: "#111827" },
  coverDateRow: { flexDirection: "row", alignItems: "center", marginTop: 4 },
  coverCalIcon: { width: 14, height: 14, borderWidth: 1.5, borderColor: "#F43F5E", borderRadius: 3, position: "relative", marginRight: 10 },
  coverCalHeader: { height: 3, backgroundColor: "#F43F5E", width: "100%", position: "absolute", top: 0 },
  coverCalDots: { flexDirection: "row", justifyContent: "space-between", paddingHorizontal: 2, marginTop: 5 },
  coverCalDot: { width: 1.5, height: 1.5, backgroundColor: "#F43F5E", borderRadius: 0.75 },
  coverDateText: { color: "#475569", fontSize: 14, fontFamily: "Roboto" },
  coverArtWrap: { position: "absolute", bottom: 10, right: -42, width: "58%", height: "auto" },
  coverArtImg: { width: "100%", height: "auto", objectFit: "contain" },
  // Page Header (shared)
  pageHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 28,
    marginBottom: 22,
    paddingTop: 10,
    paddingBottom: 12,
    borderBottomWidth: 2,
    borderBottomColor: "#C7D2FE",
  },
  pageHeaderAccent: {
    position: "absolute",
    left: 0,
    top: 8,
    bottom: 8,
    width: 6,
    backgroundColor: "#F43F5E",
    borderRadius: 3,
  },
  pageTitle: {
    fontFamily: "OpenSauce-bold",
    fontSize: 29,
    color: "#111827",
    letterSpacing: 0.2,
    marginLeft: 16,
    flex: 1,
  },
  headerMark: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#EEF2FF",
    borderRadius: 999,
    paddingVertical: 5,
    paddingHorizontal: 9,
    marginRight: 12,
  },
  headerMarkDot: {
    width: 7,
    height: 7,
    borderRadius: 3.5,
    backgroundColor: "#F59E0B",
    marginRight: 6,
  },
  headerMarkText: {
    fontSize: 7.5,
    color: "#4338CA",
    fontFamily: "Roboto-bold",
    fontWeight: "bold",
    letterSpacing: 0.8,
  },
  sectionKicker: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#FFF7ED",
    borderRadius: 999,
    paddingVertical: 6,
    paddingHorizontal: 10,
    alignSelf: "flex-start",
    marginBottom: 12,
  },
  sectionKickerDot: {
    width: 7,
    height: 7,
    borderRadius: 3.5,
    backgroundColor: "#F43F5E",
    marginRight: 6,
  },
  sectionKickerText: {
    fontSize: 9,
    color: "#9A3412",
    fontFamily: "Roboto-bold",
    fontWeight: "bold",
    letterSpacing: 0.6,
  },
  logoSmall: { width: 90, maxWidth: 90, height: "auto" },
  // Introduction (Page2)
  introRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 4,
    padding: 12,
    backgroundColor: "#FFFFFF",
    borderRadius: 18,
    borderWidth: 1.5,
    borderColor: "#DBEAFE",
  },
  introLeftCol: { width: "48%", flexDirection: "column" },
  introRightCol: { width: "48%", alignItems: "center", justifyContent: "center" },
  introSwotImage: { width: 274, height: 274 },
  introSubheading: { fontSize: 22, fontFamily: "OpenSauce-bold", fontWeight: "bold", color: "#111827", lineHeight: 1.3, marginBottom: 8 },
  introMiniDivider: { flexDirection: "row", alignItems: "center", width: 150, marginTop: 5, marginBottom: 15 },
  introMiniDividerLine: { flex: 1, height: 3, backgroundColor: "#2563EB", borderRadius: 1.5 },
  introMiniDividerDot: { width: 7, height: 7, borderRadius: 3.5, backgroundColor: "#F59E0B", marginLeft: -3 },
  introText: { fontFamily: "Roboto", fontSize: 12, lineHeight: 1.6, color: "#334155", textAlign: "justify" },
  benefitsDividerContainer: { flexDirection: "row", alignItems: "center", justifyContent: "center", marginTop: 14, marginBottom: 8, paddingHorizontal: 10 },
  benefitsDividerLine: { flex: 1, height: 2, backgroundColor: "#7C3AED", opacity: 0.55 },
  benefitsDividerDot: { width: 7, height: 7, borderRadius: 3.5, backgroundColor: "#F43F5E", marginHorizontal: 8 },
  benefitsDividerText: { fontFamily: "OpenSauce-bold", fontWeight: "bold", fontSize: 22, color: "#111827", letterSpacing: 1 },
  keyBenefitsImageWrap: {
    position: "absolute",
    bottom: 0,
    left: 0,
    width: "100%",
  },
  keyBenefitsImage: {
    width: "100%",
    height: "auto",
  },
  // Profile (Page3)
  profileCard: {
    flexDirection: "row",
    backgroundColor: "#FFFFFF",
    borderRadius: 12,
    borderWidth: 1,
    borderColor: "#E0E7FF",
    borderLeftWidth: 4,
    borderLeftColor: "#7C3AED",
    padding: 10,
    marginBottom: 8,
  },
  profileCardIndex: {
    fontSize: 10,
    fontFamily: "Roboto-bold",
    fontWeight: "bold",
    color: "#F43F5E",
    marginRight: 9,
    marginTop: 1,
  },
  careerFieldsWrap: {
    flexDirection: "column",
    alignItems: "flex-start",
  },
  careerFieldPill: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#EFF6FF",
    borderRadius: 999,
    borderWidth: 1,
    borderColor: "#BFDBFE",
    paddingVertical: 5,
    paddingHorizontal: 10,
    marginBottom: 6,
    alignSelf: "flex-start",
    maxWidth: 360,
  },
  careerFieldDot: {
    width: 7,
    height: 7,
    borderRadius: 3.5,
    backgroundColor: "#F59E0B",
    marginRight: 8,
  },
  careerFieldText: {
    fontSize: 10,
    fontFamily: "Roboto-bold",
    fontWeight: "bold",
    color: "#1E3A8A",
    maxWidth: 330,
  },
  pageArtWrap: { position: "absolute", bottom: 22, right: 8, width: "50%", height: "auto", zIndex: -1, opacity: 0.42 },
  pageArtImg: { width: "100%", height: "auto", objectFit: "contain" },
  // Career Choices (Page4)
  contentSection: { flex: 1, position: "relative" },
  flex1: {},
  careerContainer: {
    marginBottom: 16,
    padding: 13,
    backgroundColor: "#FFFFFF",
    borderRadius: 14,
    borderLeftWidth: 5,
    borderLeftColor: "#2563EB",
    borderWidth: 1,
    borderColor: "#BFDBFE",
  },
  careerTitle: { fontSize: 15, fontFamily: "OpenSauce-bold", fontWeight: "bold", marginBottom: 6, color: "#111827" },
  careerDescription: { fontSize: 12, marginBottom: 6, lineHeight: 1.5, textAlign: "justify", color: "#475569" },
  exampleHeader: { fontSize: 12, marginBottom: 4, color: "#111827" },
  bold: { fontWeight: "bold", fontFamily: "Roboto-bold" },
  exampleItem: { flexDirection: "row" },
  bulletPoint: { marginRight: 5, fontWeight: "bold", fontSize: 12, color: "#2563EB" },
  textExample: { marginBottom: 4, fontSize: 12, lineHeight: 1.5, color: "#475569" },
  swotBottomLogoContainer: { position: "absolute", bottom: 20, right: 20 },
  swotBottomLogo: { width: 100, maxWidth: 100, height: "auto", opacity: 0.74 },
  // SWOT (Page5)
  swotSectionTitle: {
    fontSize: 20,
    fontFamily: "OpenSauce-bold",
    fontWeight: "bold",
    marginBottom: 12,
    color: "#4C1D95",
  },
  swotDetailCard: {
    backgroundColor: "#FFFFFF",
    borderRadius: 13,
    borderWidth: 1,
    borderColor: "#D8E3FF",
    paddingTop: 9,
    paddingRight: 11,
    paddingBottom: 9,
    paddingLeft: 11,
    marginBottom: 9,
  },
  swotDetailHeader: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 6,
  },
  swotNumberBadge: {
    width: 22,
    height: 22,
    borderRadius: 11,
    backgroundColor: "#EFF6FF",
    borderWidth: 1,
    borderColor: "#93C5FD",
    alignItems: "center",
    justifyContent: "center",
    marginRight: 8,
  },
  swotNumberText: {
    fontSize: 10,
    color: "#2563EB",
    fontFamily: "Roboto-bold",
    fontWeight: "bold",
  },
  swotDetailTitle: {
    flex: 1,
    fontSize: 13,
    color: "#111827",
    fontFamily: "OpenSauce-bold",
    fontWeight: "bold",
    lineHeight: 1.25,
  },
  swotBodyText: {
    fontSize: 11.5,
    lineHeight: 1.5,
    color: "#475569",
    textAlign: "justify",
    paddingLeft: 30,
  },
  swotBulletRow: {
    flexDirection: "row",
    alignItems: "flex-start",
    paddingLeft: 30,
    marginBottom: 3,
  },
  swotBullet: {
    color: "#F43F5E",
    fontSize: 11,
    marginRight: 7,
    marginTop: 1,
  },
  swotBulletText: {
    flex: 1,
    fontSize: 11.5,
    lineHeight: 1.5,
    color: "#475569",
    textAlign: "justify",
  },
  contentItem2: {
    flexDirection: "row",
    alignItems: "flex-start",
    backgroundColor: "#FFFFFF",
    borderRadius: 10,
    borderWidth: 1,
    borderColor: "#E0E7FF",
    padding: 7,
    marginBottom: 5,
  },
  contentText2: { fontFamily: "Roboto", fontSize: 12, marginBottom: 0, lineHeight: 1.45, paddingHorizontal: 3, color: "#334155" },
  bulletPointName: { fontSize: 13, fontFamily: "OpenSauce-bold", fontWeight: "bold", marginTop: 8, color: "#111827" },
  bulletPointOpportunitiesText: { marginLeft: 2, fontSize: 13, lineHeight: 1.6, textAlign: "justify", color: "#475569" },
  // Threats (Page6)
  threatList: { marginLeft: 0 },
  threatItemFieldName: { flexDirection: "row", alignItems: "flex-start", marginBottom: 0 },
  // Contact (Page7)
  logoBigContainer: { flexDirection: "row", justifyContent: "center", marginTop: 30, marginBottom: 10 },
  logobig: { width: 150, maxWidth: 150, height: "auto" },
  counselingImage: { width: "100%", height: "auto" },
  counselingImageContainer: {
    backgroundColor: "#FFFFFF",
    borderRadius: 18,
    borderWidth: 1,
    borderColor: "#BFDBFE",
    padding: 8,
    marginHorizontal: 10,
  },
  button: { backgroundColor: "#F43F5E", paddingVertical: 11, paddingHorizontal: 28, borderRadius: 999, alignSelf: "center", marginBottom: 20, marginTop: 20 },
  buttonText: { color: "#fff", fontFamily: "OpenSauce-bold", fontWeight: "bold", fontSize: 14 },
  addressSection: { marginHorizontal: 15, marginVertical: 14 },
  addressItem: {
    flexDirection: "row",
    marginBottom: 10,
    alignItems: "flex-start",
    backgroundColor: "#FFFFFF",
    borderRadius: 12,
    borderWidth: 1,
    borderColor: "#E0E7FF",
    padding: 9,
  },
  icon: { width: 18, height: 18, marginTop: 2 },
  addressMain: { fontSize: 11, lineHeight: 1.5, color: "#475569" },
  addressTitle: { fontFamily: "Roboto-bold", fontWeight: "bold", color: "#111827" },
  contactText: { fontSize: 12, fontFamily: "Roboto", marginLeft: 10, color: "#1E293B" },
  contactSection: { marginTop: 15, marginLeft: 15 },
  contactItem: { flexDirection: "row", alignItems: "center", marginBottom: 10 },
  contactIcon: { width: 24, height: 24, backgroundColor: "#2563EB", borderRadius: 12, padding: 4 },
});

